// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import EmailSvg from '@rsuite/icon-font/lib/file/Email';
var Email = createSvgIcon({
  as: EmailSvg,
  ariaLabel: 'email',
  category: 'file',
  displayName: 'Email'
});
export default Email;